import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const Ads = () => import('./views/Index.vue');

export default [
  {
    path: '/ads',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'Ads',
        component: Ads,
        meta: { title: i18n.global.t('ads.ads') },
      },
    ],
  },
];
